module.exports = __webpack_public_path__ + "img/tagSign1.0b98c499.png";